module.exports = __webpack_public_path__ + "static/img/chuzhonghuaxue3.bf53b36e.jpg";